// extracted by mini-css-extract-plugin
export default {"avatar":"avatar_QTdBx","userinfo":"userinfo_bq0Tj","info":"info_ABt80"};